import { useQuery } from 'react-query';
import { dataFetch, DIGGER_API_SUFFIX } from '../../axios/customAxios';

const useGetCustomFields = (identifier: string, formType: number) => useQuery(
  [`fields_${identifier}`],
  () => dataFetch.get(`${DIGGER_API_SUFFIX}custom-fields/${formType}`).then((res) => res.data),
);

export default useGetCustomFields;
